import React, { useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import { _post } from "../../../Api";
import { toast } from "react-toastify";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import cloudStore from "../../../store/CloudStore";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DialogContentText } from "@material-ui/core";

export default function AddAccountDialog(props) {
  const [getDialogType, setDialogType] = [props.getType, props.setType];
  const [merchant, setMerchant] = React.useState(null);
  const [password, setPassword] = React.useState(props.password);

  const merchantId = props.merchant.id;

  const [handheldUser] = React.useState({
    username: "",
    password: "",
    inhouse: undefined,
    takeaway: undefined,
    use_menu_tags: undefined,
  });

  const [orderUser] = React.useState({
    email: undefined,
    app_version: 3,
    open_url: undefined,
    password: undefined,
  });

  const [cloudUser] = React.useState({
    email: undefined,
    password: undefined,
    sendEmail: false,
  });

  function onChange() {
    const merchant = {
      id: cloudStore.merchant.id,
      inhouse: cloudStore.merchant.sp_merchants[0] ? !!cloudStore.merchant.sp_merchants[0].id : undefined,
      takeaway: cloudStore.merchant.ta_merchants[0] ? !!cloudStore.merchant.ta_merchants[0].id : undefined,
    };
    setMerchant(merchant);
  }

  useEffect(() => {
    cloudStore.addChangeListener(onChange);
    if (cloudStore.merchant != null) {
      onChange();
    }
    return () => cloudStore.removeChangeListener(onChange);
  }, []);

  /**
   * After post request was successful, this method closes the dialog
   */
  function closeDialog() {
    setDialogType(null);
  }

  /**
   * This function is a callback of addHandheldAccount and sends a post request to the server
   */
  function addHandheldUser() {
    if (!!!handheldUser.inhouse && !!!handheldUser.takeaway) {
      toast.error("Inhouse or Takeaway must be selected.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    if (!!!handheldUser.username || !!!handheldUser.password) {
      toast.error("Username and password are required.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    _post("/nova/merchant/" + merchantId + "/handheld", handheldUser)
      .then((_) => {
        toast.success("New handheld account was successfully added!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        closeDialog("handheld");
        props.setHandheldChange(!props.handheldChange);
      })
      .catch((e) => {
        toast.error("New handheld account could not be added.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log(e);
      });
  }

  /**
   * This generates the dialog for adding a new handheld account
   * @returns {JSX.Element}
   */
  function addHandheldAccount() {
    return (
      <Dialog open={!!getDialogType()} onClose={closeDialog}>
        <DialogTitle>Adding new handheld account</DialogTitle>
        <DialogContent>
          <DialogContentText>Please select your options and fill in a username and a password.</DialogContentText>
          <FormControlLabel
            style={{ margin: "1em" }}
            control={<Checkbox onClick={(event) => (handheldUser.inhouse = event.target.checked)} />}
            label={"Inhouse"}
            labelPlacement={"top"}
            disabled={!merchant.inhouse}
          />
          <FormControlLabel
            style={{ margin: "1em" }}
            control={<Checkbox onClick={(event) => (handheldUser.takeaway = event.target.checked)} />}
            label={"Takeaway"}
            labelPlacement={"top"}
            disabled={!merchant.takeaway}
          />
          <FormControlLabel
            style={{ margin: "1em" }}
            control={<Checkbox onClick={(event) => (handheldUser.use_menu_tags = event.target.checked)} />}
            label={"gebruik menus"}
            labelPlacement={"top"}
          />
          <Paper variant={"outlined"} style={{ margin: "1em" }}>
            <TextField
              autoFocus
              margin="dense"
              id="handheld username"
              label="Username"
              type="text"
              required
              onChange={(event) => {
                handheldUser.username = event.target.value;
              }}
            />
          </Paper>
          <Paper variant={"outlined"} style={{ margin: "1em" }}>
            <TextField
              margin="dense"
              id="handheld password"
              label="Password"
              type="text"
              onChange={(event) => {
                setPassword(event.target.value);
                handheldUser.password = event.target.value;
              }}
              value={password}
            />
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color={"primary"}>
            Cancel
          </Button>
          <Button onClick={addHandheldUser} color={"primary"}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  /**
   * This function sends a post request to add a new order user
   */
  function addOrderUser() {
    /**
     * An orderuser needs an email address
     */
    if (!!!orderUser.email) {
      toast.error("Please enter a username.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    /**
     * An order user needs a password
     */
    if (!!!orderUser.password) {
      toast.error("Please enter a password.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    /**
     * An order user needs to have an app version specified
     */
    if (!!!orderUser.app_version && orderUser.app_version <= 0) {
      toast.error("Please enter an app version higher than zero.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    _post("/nova/merchant/" + merchantId + "/mynbonnenuser", orderUser)
      .then((_) => {
        toast.success("New order account was successfully added!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        closeDialog("order");
        props.setOrderChange(!props.orderChange);
      })
      .catch((e) => {
        toast.error("New order account could not be added.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log(e);
      });
  }

  /**
   * This function generates the dialog for adding a new order account
   * @returns {JSX.Element}
   */
  function addOrderAccount() {
    return (
      <Dialog open={!!getDialogType()} onClose={closeDialog}>
        <DialogTitle>Adding new order account</DialogTitle>
        <DialogContent>
          <DialogContentText>Please enter your email address, app version, open url and password</DialogContentText>
          <Paper variant={"outlined"} style={{ margin: "1em" }}>
            <TextField
              autoFocus
              margin="dense"
              id="order email"
              label="Email"
              type="email"
              onChange={(event) => {
                orderUser.email = event.target.value;
              }}
            />
          </Paper>
          <Paper variant={"outlined"} style={{ margin: "1em" }}>
            <TextField
              margin="dense"
              id="handheld password"
              label="Password"
              type="text"
              onChange={(event) => {
                orderUser.password = event.target.value;
                setPassword(event.target.value);
              }}
              value={password}
            />
          </Paper>
          <Paper variant={"outlined"} style={{ margin: "1em" }}>
            <TextField
              margin="dense"
              id="order open url"
              label="Open url"
              type="url"
              onChange={(event) => {
                orderUser.open_url = event.target.value;
              }}
            />
          </Paper>
          <Paper variant={"outlined"} style={{ margin: "1em" }}>
            <TextField
              margin="dense"
              id="order app version"
              label="App version"
              type="number"
              disabled={true}
              value={3}
            />
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color={"primary"}>
            Cancel
          </Button>
          <Button onClick={addOrderUser} color={"primary"}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  /**
   * This function sends a post request to add a new cloud user
   */
  function addCloudUser() {
    if (!!!cloudUser.email) {
      toast.error("Please enter a email.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    _post("/nova/merchant/" + merchantId + "/cloudaccount", cloudUser)
      .then(() => {
        toast.success("New cloud account was successfully added!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        closeDialog("cloud");
        props.setCloudChange(!props.cloudChange);
      })
      .catch((e) => {
        toast.error("New cloud account could not be added.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log(e);
      });
  }

  /**
   * This function generates the dialog for adding a new cloud account
   * @returns {JSX.Element}
   */
  function addCloudAccount() {
    return (
      <Dialog open={!!getDialogType()} onClose={closeDialog}>
        <DialogTitle>Adding new cloud account</DialogTitle>
        <DialogContent>
          <DialogContentText>Please enter your email address and password.</DialogContentText>
          <Paper variant={"outlined"} style={{ margin: "1em" }}>
            <TextField
              autoFocus
              margin="dense"
              id="order email"
              label="Email"
              type="email"
              onChange={(e) => {
                cloudUser.email = e.target.value;
              }}
            />
          </Paper>
          <Paper variant={"outlined"} style={{ margin: "1em" }}>
            <TextField
              margin="dense"
              id="handheld password"
              label="Password"
              type="text"
              value={password}
              onChange={(event) => {
                setPassword(event.target.value);
                cloudUser.password = event.target.value;
              }}
            />
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color={"primary"}>
            Cancel
          </Button>
          <Button onClick={addCloudUser} color={"primary"}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  /**
   * When merchant has not been loaded yet, show wait symbol
   */
  if (!cloudStore.merchant) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  /**
   * On render, check which dialog needs to pop up. If no type,
   */
  switch (getDialogType()) {
    case "handheld":
      return addHandheldAccount();
    case "order":
      return addOrderAccount();
    case "cloud":
      return addCloudAccount();

    default:
      return <div />;
  }
}
